export const Footer = ({resultCheck, disabledButton, onCheckButtonClicked, onClearButtonClicked, licenseplate, settings}) => {

    const onRequestButtonClicked = () => {
        if (settings && settings.ELOKET_URL){
            window.location.href = `${settings.ELOKET_URL}welcome?licenseplate=${licenseplate}`
        }
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && disabledButton === true) {
            e.preventDefault()
        }
    }

    return (
                <div className="footer">
                    <div className='button-wrap'>
                        {resultCheck === null &&
                            <button className={disabledButton === true ? "btn check-btn disabled" : "btn check-btn"}
                                onKeyDown={handleKeyDown}
                                onClick={onCheckButtonClicked}>
                                Check kenteken
                            </button>
                        }

                        {resultCheck !== null &&
                            <button className= "btn blue clear-btn"
                                onClick={onClearButtonClicked}>
                                Check een ander kenteken
                            </button>
                        }

                        {resultCheck !== null && resultCheck.need_exemption === true &&
                            <button className= "btn req-btn" onClick={onRequestButtonClicked}>
                                Vraag ontheffing aan
                            </button>
                        }
                    </div>
                </div>
    );
}
